module.exports = __webpack_public_path__ + "img/04cpyf.e15c0a50.svg";